<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-3">
						<div class="avatar-upload-histequipo">
                            <div v-show="!Disabled" class="avatar-edit">
                                <input :disabled="Disabled" id="file" @change="CambiarImagen($event)" ref="file" type="file" name="file" accept=".png, .jpg, .jpeg">
                                <label for="file"></label>
                            </div>
                            <div class="avatar-edit2">
                                <button type="button" data-backdrop="static"
                                data-toggle="modal"
                                data-target="#imagenrefaccion" @click="ZoomImagen(ImagenAMostrar)">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                            <!-- <div v-if="BndImagenEquipo!=0" class="avatar-edit3">
                                <button type="button" @click="GuardarImagenEquipo">
                                    <i class="fas fa-save"></i>
                                </button>
                            </div> -->
                            <div class="avatar-preview">
                                <div id="imagePreview" :style="'background-image: url('+ImagenAMostrar+');'" :src="ImagenAMostrar">
                                </div>
                            </div>
                        </div>
					</div>
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-3">
                    		    <label >SKU </label>
                    		    <input :disabled="Disabled" type="text" v-model="Refaccion.Sku" class="form-control" placeholder="SKU" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Sku" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Ítem </label>
								<div class="position-relative">
									<!-- <input type="text" v-model="material.Item" class="form-control" placeholder="Ítem" @input="onInput" @blur="hideSuggestions" @focus="onFocus"/>
									<ul v-if="ShowList && ItemFiltrado.length" class="suggestions">
										<li v-for="(item,index) in ItemFiltrado" :key="index" @mousedown.prevent="selectSuggestion(item)">
											{{item}}
										</li>
									</ul> -->
									<input :disabled="Disabled" type="text" v-model="Refaccion.Item" class="form-control" placeholder="Ítem"/>
								</div>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
								<label for="">Unidad</label>
								<div class="position-relative">
									<!-- <input type="text" class="form-control" v-model="material.Unidad" placeholder="Unidad" @input="onInputUnidad" @blur="hideSuggestionsUnidad" @focus="onFocusUnidad">
									<ul v-show="ShowListUnidad && UnidadFiltrado.length" class="suggestions">
										<li v-for="(item,index) in UnidadFiltrado" :key="index" @mousedown.prevent="selectSuggestionUnidad(item)">
											{{item}}
										</li>
									</ul> -->
									<input :disabled="Disabled" type="text" class="form-control" v-model="Refaccion.Unidad" placeholder="Unidad">
								</div>
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="this.errorvalidacion.Unidad[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Marca</label>
								<input :disabled="Disabled" type="text" class="form-control" v-model="Refaccion.Marca" placeholder="Marca">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="this.errorvalidacion.Marca[0]"></Cvalidation></label>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label>Modelo</label>
								<input :disabled="Disabled" type="text" class="form-control" v-model="Refaccion.Modelo" placeholder="Modelo">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="this.errorvalidacion.Modelo[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Número de Parte</label>
								<input :disabled="Disabled" type="text" class="form-control" v-model="Refaccion.NumParte" placeholder="Número de Parte">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NumParte" :Mensaje="this.errorvalidacion.NumParte[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                		        <label >Costo Unitario</label>
                		        <vue-numeric :disabled="Disabled" placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="Refaccion.Valor"></vue-numeric>
                		        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Valor" :Mensaje="this.errorvalidacion.Valor[1]"></Cvalidation></label>
                		    </div>
							<div class="col-lg-3">
								<label for="">Stock</label>
								<select :disabled="Disabled" v-model="Refaccion.Stock" class="form-control">
									<option value="">- Stock -</option>
									<option value="stock">Stock</option>
									<option value="bajo pedido">Bajo Pedido</option>
								</select>
								<!-- <input type="number" class="form-control" v-model="Refaccion.Stock" placeholder="Stock"> -->
								<!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Stock" :Mensaje="this.errorvalidacion.Stock[0]"></Cvalidation></label> -->
							</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label for="">Tipo</label>
								<select :disabled="Disabled" v-model="Refaccion.Tipo" class="form-control">
									<option value="">-Tipo-</option>
									<option value="1">Genérico</option>
									<option value="2">OEM</option>
								</select>
							</div>
							<div class="col-lg-5">
								<label for="">Archivo</label>
                        		<div class="custom-file-input-image">
                        		    <input :disabled="Disabled" @change="SubirArchivo()" type="file" accept="application/pdf" ref="archivo" class="custom-file-input" id="validatedCustomFile" required>
                        		    <input :disabled="Disabled" type="text" v-model="NombreArchivo" class="form-control">
                        		    <button :disabled="Disabled" type="button" class=""><i class="fas fa-paperclip"></i></button>
                        		</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea v-model="Refaccion.Descripcion" maxlength="70" cols="30" rows="1" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
			</template>
		</CLoader>
		<Modal :Showbutton="false" :NameModal="'imagenrefaccion'" :Nombre="'Imagen'" :TipoM="2">
            <template slot="Form">
				<div class="form-row justify-content-center align-items-center">
					<img :src="ImagenAMostrar" alt="Aún no hay una imagen para mostrar" class="img-thumbnail">
				</div>
			</template>
        </Modal>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import Config from "@/helpers/VarConfig.js";
import Modal from '@/components/Cmodal.vue';

export default {
	name:'Form',
    props:['NameList','poBtnSave','pDisabled'],
	components:{
        Cbtnsave,
        Clist,Cvalidation,Modal
    },
	data() {
		return {
			Modal:true,//Sirve pra los botones de guardado
            FormName:'tipounidad',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			Refaccion:{
				IdRefaccion:0,
				Descripcion:'',
				Marca:'',
				Modelo:'',
				NumParte:'',
				Tipo:'',
				Valor:'',
				Sku:'',
				Item:'',
				Stock:'',
				Unidad:'',
				Foto:'',
				Archivo:''
			},
			errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ValidElement:Config.validImage2m,
			ImagenAMostrar:'',
			NombreArchivo:'',
			Disabled:false
		}
	},
	methods: {
		async Guardar(){
			this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			let image=this.$refs.file.files[0];
			let file=this.$refs.archivo.files[0];
			formData.set('IdRefaccion',this.Refaccion.IdRefaccion);
			formData.set('Descripcion',this.Refaccion.Descripcion);
			formData.set('Marca',this.Refaccion.Marca);
			formData.set('Modelo',this.Refaccion.Modelo);
			formData.set('NumParte',this.Refaccion.NumParte);
			formData.set('Tipo',this.Refaccion.Tipo);
			formData.set('Valor',this.Refaccion.Valor);
			formData.set('Sku',this.Refaccion.Sku);
			formData.set('Item',this.Refaccion.Item);
			formData.set('Stock',this.Refaccion.Stock);
			formData.set('Unidad',this.Refaccion.Unidad);
			formData.set('Foto',this.Refaccion.Foto);
			formData.append('FotoFile',image);
			formData.set('Archivo',this.Refaccion.Archivo);
			formData.append('ArchivoFile',file);
			await this.$http.post(
                'refaccionesdistribuidor/post',
                formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }  
            }
            ).then((res)=>{
				this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion);
			}).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  
            });
		},
		Limpiar(){
			this.Refaccion={
				IdRefaccion:0,
				Descripcion:'',
				Marca:'',
				Modelo:'',
				NumParte:'',
				Tipo:'',
				Valor:'',
				Sku:'',
				Item:'',
				Stock:'',
				Unidad:'',
				Foto:'',
				Archivo:''
			};
			this.errorvalidacion=[];
			this.ImagenAMostrar='';
			this.NombreArchivo='';
			this.$refs.file.value=null;
		},
		get_one()
        {
            this.$http.get(
                'refaccionesdistribuidor/recovery',
                {
                    params:{IdRefaccion: this.Refaccion.IdRefaccion}
                }
            ).then( (res) => {
                this.Refaccion=res.data.data.refaccion;
				this.ImagenAMostrar=res.data.data.ruta+this.Refaccion.Foto;
				this.NombreArchivo=res.data.data.refaccion.Archivo;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		CambiarImagen(target){
            this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreview'));
        },
		ZoomImagen(Imagen){
            if (this.$refs.file.files[0]!=undefined) {
				let ImagenPreview=document.getElementById("imagePreview");
				const Estilos=window.getComputedStyle(ImagenPreview);
				let CadenaBase=Estilos.backgroundImage;
				let Url=CadenaBase.slice(5,-2);
				this.ImagenAMostrar=Url;
			}
			else{
				this.ImagenAMostrar=Imagen;
			}
        },
		SubirArchivo(){
			const image = this.$refs.archivo.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 5) {
                this.$toast.info('Solo se puede subir archivos menores a 5 MB');
                const  input  = this.$refs.archivo;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.archivo;
                input.type = 'text'
                input.type = 'file';
                this.NombreArchivo='Elegir archivo (5MB)';
                return false;
            }

            this.NombreArchivo=image.name;
		}
	},
	created() {
		this.bus.$off('Save_'+this.EmitSeccion);
        this.bus.$off('NewModal_'+this.EmitSeccion);

        this.bus.$on('Save_'+this.EmitSeccion,()=>
        {
           this.Guardar();
        });
        
        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {   
			// this.ListItem();
			// this.ListUnidad();
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
             this.Limpiar();
            if (Id>0)
            {
                this.Refaccion.IdRefaccion=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
            
        });
	},
	mounted() {
		if (this.pDisabled!=undefined) {
			this.Disabled=this.pDisabled;
		}
	},
}
</script>

<style>

</style>
